// Money rounding helpers. Keep calculations deterministic by working in cents.

export function roundCents(value: number): number {
  return Math.round(value);
}
